import * as base64 from '@protobufjs/base64';
import {ResourceWebP} from '@gongxigames/framework/core/fragments/WebP/ResourceWebP';
import {BaseTexture, Texture} from 'pixi.js';

export function decodeImageWebP(
    data: Uint8Array,
    resolution: number,
    width: number,
    height: number
): Texture {
    const resource: ResourceWebP = {
        binWebP: data,
        type: 'WebP'
    };
    const options = {
        resolution,
        width,
        height,
        resourceOptions: {width, height}
    };

    const baseTexture = BaseTexture.from(resource as any, options);

    return new Texture(baseTexture);
}

export function decodeImage(data: Uint8Array, type: string, resolution: number): Texture {
    const base64data = base64.encode(data, 0, data.length);
    const baseTexture = BaseTexture.from(`data:${type};base64,` + base64data, {resolution});

    return new Texture(baseTexture);
}
